import { render, staticRenderFns } from "./DashboardSetupChecklist.vue?vue&type=template&id=0da471f0&scoped=true"
import script from "./DashboardSetupChecklist.vue?vue&type=script&lang=js"
export * from "./DashboardSetupChecklist.vue?vue&type=script&lang=js"
import style0 from "./DashboardSetupChecklist.vue?vue&type=style&index=0&id=0da471f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da471f0",
  null
  
)

export default component.exports